import Model from './index';

export default {
  getAll(sortField, sortOrder, limit, offset) {
    return Model.get('/v1/organizations', {
      params: {
        sort_field: sortField,
        sort_order: sortOrder,
        limit,
        offset,
      },
    });
  },
  getOne(id) {
    return Model.get(`/v1/organization/${id}`);
  },
  add(obj) {
    return Model.post('/v1/organizations', obj);
  },
  update(obj) {
    return Model.put(`/v1/organization/${obj.id}`, obj);
  },
  delete(id) {
    return Model.delete(`/v1/organization/${id}`);
  },
};
